"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const serviceHistory = { 
  getServiceHistoryActions: function () {
    return api.get("/ServiceHistories/Actions", WithToken.headersToken({ }, configuration.cookieName));
  },
  getServiceHistory: function (options) {
    return api.get("/ServiceHistories", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  createServiceHistoryComment: function (id, options) {
    return api.post(`/ServiceHistories/${id}/Commentaries`, options, WithToken.headersToken({}, configuration.cookieName));
  },
};

export default serviceHistory;
